/** Fixed global header, including the mobile CUI notice. */
export const GLOBAL_NAVBAR_HEIGHT = { xs: 96, sm: 64 } as const;
export const GLOBAL_NAVBAR_Z_INDEX = 2000;
